/** Figma 9261-8293 "Share your thoughts" modal is a 600px Modal-Basic. */
export const FEEDBACK_MODAL_WIDTH = 600;

/** Mirrors ``MAX_DETAILS_LENGTH`` in ``backend/app/feedback/service.py``. */
export const FEEDBACK_DETAILS_MAX_LENGTH = 5000;

/**
 * "Select Category" options. ``value`` is the ClickUp "Feedback Type" option
 * name 1:1 (the backend resolves option ids by name), ``iconSlug`` is the
 * matching Spark icon pulled from Figma 9261-8293.
 */
export const FEEDBACK_CATEGORIES = Object.freeze([
    { value: 'Compliment', iconSlug: 'feedback-compliment' },
    { value: 'Feature idea', iconSlug: 'feedback-feature-idea' },
    { value: 'Found a Bug', iconSlug: 'feedback-bug' },
    { value: 'Performance', iconSlug: 'feedback-performance' },
    { value: 'Documentation', iconSlug: 'feedback-documentation' },
    { value: 'Billing', iconSlug: 'feedback-billing' },
    { value: 'Other', iconSlug: 'feedback-other' },
]);

/** Spark ``SentimentRating`` value → ClickUp "Customer Sentiment" option name. */
export const FEEDBACK_SENTIMENTS = Object.freeze({
    negative: 'Negative',
    neutral: 'Neutral',
    positive: 'Positive',
});

/** Attachment limits (mirrored by the backend attachment route). */
export const FEEDBACK_MAX_ATTACHMENTS = 5;
export const FEEDBACK_MAX_ATTACHMENT_BYTES = 1024 * 1024 * 1024; // 1 GiB (ClickUp per-file cap)
export const FEEDBACK_ALLOWED_IMAGE_TYPES = Object.freeze(['image/png', 'image/jpeg', 'image/gif', 'image/webp']);

/** Error helper copy shown under "Tell us more" (Figma 9261-8847 danger state). */
export const FEEDBACK_ATTACHMENT_LIMIT_ERROR = 'Upload failed: Maximum 5 files and 1GB per file allowed.';
export const FEEDBACK_ATTACHMENT_TYPE_ERROR = 'Only image files (PNG, JPG, GIF, WEBP) are supported.';
